/**
 * NoAccess Component
 *
 * Features:
 * - Displays a message and actions when the user does not have access to a lesson or course.
 * - Shows login or purchase options based on academy product type.
 * - Passes relevant props to child components for course and academy info.
 * - Uses Material-UI and CSS modules for styling.
 *
 * @param {Object} props - Component properties
 * @param {number} [props.idCourse] - Course ID for purchase link
 * @param {number} [props.idEmisor] - Emisor ID for purchase link
 * @param {string} [props.academyName] - Academy name for purchase link
 * @returns {JSX.Element} Rendered NoAccess component
 */
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import classes from './NoAccess.module.css';

const NoAccess = props => {
  const { t } = useTranslation(['noAccess']);
  const dataAcademy = useSelector(state => state.academyInfo);

  return (
    <aside className={classes.noAccessContainer}>
      <h3 className={classes.title}>{t('title')}</h3>
      {/* Show login or purchase options based on academy product type */}
      {dataAcademy.data.productType === 1 ? (
        <>
          <p className={classes.text}>{t('loginText')}</p>
          {/* Material-UI Button for login, uses Link from react-router-dom */}
          <Button
            className={classes.buyBtn}
            component={Link}
            to="/login"
          >
            {t('login')}
          </Button>
        </>
      ) : dataAcademy.data.productType === 2 ? (
        <p>Ingresa con una cuenta que tenga acceso.</p>
      ) : (
        <>
          <p className={classes.text}>{t('text')}</p>
          {/* Material-UI Button for purchase, uses anchor link */}
          <Button
            className={classes.buyBtn}
            component="a"
            target="_blank"
            href={`https://pagos.mayahii.com/cart/checkout/academy/course/${props.idEmisor}/${props.academyName}/${props.idCourse}`}
          >
            {t('buy')}
          </Button>
        </>
      )}
    </aside>
  );
};

/**
 * PropTypes definition for type checking and development documentation
 */
NoAccess.propTypes = {
  /** Course ID for purchase link */
  idCourse: PropTypes.number,
  /** Emisor ID for purchase link */
  idEmisor: PropTypes.number,
  /** Academy name for purchase link */
  academyName: PropTypes.string
};

NoAccess.defaultProps = {
  idCourse: undefined,
  idEmisor: undefined,
  academyName: undefined
};

export default NoAccess;
